const observerTarget = document.querySelector(".product-form__buttons");
let lastScrollY = window.scrollY;
let isScrollingDown = true;
let callback = (entries, observer) => {
  entries.forEach((entry) => {
    let currentScrollY = window.scrollY;
    isScrollingDown = currentScrollY > lastScrollY;
    lastScrollY = currentScrollY;

    /* shopify design mode is causing the sticky cart to show when it shouldn't */
    if (isScrollingDown) {
      if (
        !entry.isIntersecting &&
        window.innerWidth >= 750 &&
        !Shopify.designMode
      ) {
        document
          .querySelector(".product__sticky-cart")
          .classList.remove("is-hidden");
      } else if (
        !entry.isIntersecting &&
        window.innerWidth < 750 &&
        window.scrollY > window.innerHeight &&
        !Shopify.designMode
      ) {
        document
          .querySelector(".product__sticky-cart")
          .classList.remove("is-hidden");
      } else {
        document
          .querySelector(".product__sticky-cart")
          .classList.add("is-hidden");
      }
    } else {
      // Yukarı kaydırma
      if (entry.isIntersecting) {
        document
          .querySelector(".product__sticky-cart")
          .classList.add("is-hidden");
      }
    }
  });
};

let observer = new IntersectionObserver(callback, { threshold: 0.8 });

document.addEventListener("DOMContentLoaded", initStickyCart);
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", initStickyCart);
  document.addEventListener("shopify:section:unload", () => {
    observer.unobserve(observerTarget);
  });
}

function initStickyCart() {
  observer.observe(observerTarget);
}
